import { createSlice } from '@reduxjs/toolkit';

const appointmentSlice = createSlice({
    name : 'appointment',
    initialState : {
        appointments: null,
        logs: null,
        patientAppointments: null,
    },
    reducers : {
        setAppointments: (state , action) => {
            state.appointments = action.payload.data;
            state.logs = action.payload.logs;
        },
        setPatientAppointments: (state , action) => {
            state.patientAppointments = action.payload;
        },
    }
})


export const { 
    setAppointments,
    setPatientAppointments,
} = appointmentSlice.actions;

export default appointmentSlice.reducer;